<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Boards|Working with Boards') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Boards|This Kanban board allows you to visualize tasks as cards organized in columns. You can drag and drop tasks between columns, apply filters, and customize the view.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Columns') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Each column represents a workflow status or stage. Click "Manage Columns" to add, edit, or remove columns and assign workflow statuses to them.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Moving Tasks') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Drag and drop tasks between columns to change their status. If multiple workflow transitions are available, you will be prompted to choose one. Tasks can also be moved within a column to reorder them.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Filters') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Use the filter panel to show only specific tasks (by assignee, priority, labels, etc.). You can save filters for your current session or set them as the board default (if you have permissions).'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Ordering') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Choose how tasks are sorted within each column (by creation date, priority, due date, etc.). Ordering can be saved for your session or as the board default.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Swimlanes') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Swimlanes allow you to group tasks horizontally by assignee, author, due date, category, status, priority, or project. This provides an additional dimension for organizing your tasks.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Load More') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Each column initially shows a limited number of tasks. Click "Load More" at the bottom of a column to see additional tasks.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Boards|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
